<template>
<div class="col mb-4">
    <div class="card">
        <transition :duration="{ enter: 500, leave: 800 }">
            <router-link :to="{ name: card.category , params: { id: card.id }}">
                <img :src="card.images[0].src" class="card-img-top" height="250" />
                <div class="card-body">
                    <h5 class="card-title">{{card.title}}</h5>
                    <p class="card-text">{{card.description1}}</p>
                    <p class="card-text">
                        <small class="text-muted">{{card.date}}</small>
                    </p>
                </div>
            </router-link>
        </transition>
    </div>

</div>
</template>

<script>
export default {
    name: 'card',
    props: ['card']
}
</script>

<style scoped>
.card {
    background-color: black;
}

.card-title {
    color: white;
}

.card-text {
    color: grey;
}

img {
    object-fit: cover;
}
</style>
